import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Params, Router } from '@angular/router'
import { StripHtmlPipe } from 'src/app/shared/pipes/strip-html.pipe'

import { ExpertGroupPortal } from 'src/app/shared/interfaces/expert-group-portal.interface'
import { TaxonomyTerm } from 'src/app/shared/interfaces/taxonomy-term.interface'
import { TagService } from 'src/app/shared/services/tag.service'
import { Discussion } from '../../../../../shared/interfaces/discussion.interface'
import { Page } from '../../../../../shared/interfaces/page.interface'
import { Paginator } from '../../../../../shared/interfaces/paginator.interface'
import { MetaService } from '../../../../../shared/services/meta.service'
import { PageService } from '../../../../../shared/services/page-service/page.service'
import { DiscussionService } from '../../../services/discussion.service'
import { ExpertGroupPortalService } from '../../../services/expert-group-portal.service'

@Component({
  selector: 'app-discussion-list',
  templateUrl: './discussion-list.component.html',
  styleUrls: ['./discussion-list.component.scss']
})
export class DiscussionListComponent implements OnInit {
  discussionListPage: Page
  paginator: Paginator<Discussion>

  loadingDiscussionListPage: boolean
  loadingPaginator: boolean

  baseUrl: string
  expertGroupPortal: ExpertGroupPortal

  constructor(
    private pageService: PageService,
    private discussionService: DiscussionService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private metaService: MetaService,
    private stripHtmlPipe: StripHtmlPipe,
    private expertGroupPortalService: ExpertGroupPortalService,
    private tagService: TagService
  ) {}

  async ngOnInit() {
    this.activatedRoute.queryParams.subscribe(async (queryParams: Params) => {
      // Get the current expert group portal without the query params (page for example)
      this.baseUrl = await this.router.url.split('?')[0]

      // The id of the current expert group portal, it's always one string before the last slash
      const expertGroupPortalId: string = this.baseUrl.split('/').slice(-2)[0]

      this.expertGroupPortal =
        this.expertGroupPortalService.getExpertGroupPortalById(
          expertGroupPortalId
        )

      this.loadingDiscussionListPage = true
      this.discussionListPage = await this.pageService.show(
        this.expertGroupPortal.slug + '-discussions'
      )
      this.loadingDiscussionListPage = false

      const tagPromises: Promise<TaxonomyTerm>[] =
        this.expertGroupPortal.tagSlugs.map((tagSlug) =>
          this.tagService.showBySlug(tagSlug)
        )

      return Promise.all(tagPromises).then((tags: TaxonomyTerm[]) => {
        this.loadingPaginator = true

        // Set the meta tags of the current page
        this.metaService.setTags({
          title:
            this.discussionListPage.metaTitle || this.discussionListPage.title,
          description: this.stripHtmlPipe.transform(
            this.discussionListPage.metaDescription ||
              this.discussionListPage.excerpt
          ),
          path: this.expertGroupPortal.id + '/discussions',
          absoluteOgImage: this.discussionListPage.image
            ? this.discussionListPage.image.socialCard ||
              this.discussionListPage.image.landscape ||
              this.discussionListPage.image.videoCard
            : this.metaService.defaultMeta.absoluteOgImage
        })

        // Get the discussions of the current expert group portal only when the tag ids are ready.
        return this.discussionService
          .listPaginated({
            tagIds: tags.map((tag: TaxonomyTerm) => tag.id),
            page: queryParams.page
          })
          .then((paginator: Paginator<Discussion>) => {
            this.paginator = paginator
            this.loadingPaginator = false
            return
          })
      })
    })
  }

  goToPage(pageNumber: number) {
    const queryParams: Params = {
      page: pageNumber
    }
    this.router.navigate([this.baseUrl], {
      queryParams,
      queryParamsHandling: 'merge'
    })
  }
}
